<template>
    <vx-table-row>
        <vx-table-row-item>
            <template v-slot:label>Status:</template>
            <group-status-badge :status="props.modelValue.status" />
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label>Changed by:</template>
            <div v-if="props.modelValue.user" class="flex flex-col">
                <span>{{ props.modelValue.user.name || '-' }}</span>
                <span v-if="props.modelValue.user.email" class="text-xs text-slate-500">
                    {{ props.modelValue.user.email }}
                </span>
            </div>
            <span v-else>System</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label>Changed at:</template>
            {{ shortDateTime(props.modelValue.created_at) }}
        </vx-table-row-item>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { VxTableRow, VxTableRowItem } from '@voxie/frontend-components';
import GroupStatusBadge from '~/components/general/GroupStatusBadge.vue';
import { shortDateTime } from '~/utils/date';
import type { GroupStatus } from '~/constants/groupStatuses';

export interface GroupStatusLogEntry {
    id: number;
    team_id: number;
    group_id: string;
    action: 'create' | 'update' | 'delete';
    status: GroupStatus;
    user: {
        id: number;
        name: string | null;
        email: string | null;
    } | null;
    created_at: string;
}

const props = defineProps<{
    modelValue: GroupStatusLogEntry;
}>();
</script>
